// extracted by mini-css-extract-plugin
module.exports = {"w1qj19x7":"w1qj19x7"};